import { put, select } from 'redux-saga/effects';
import { fetchReceiptStatisticsAllRequest } from '../actions';
import { getReceiptStatisticsDateRange } from '../selectors';

export function* refreshReceiptStatisticsSaga() {
  const dateRange = yield select(getReceiptStatisticsDateRange);
  yield put(fetchReceiptStatisticsAllRequest(dateRange ?? {}));
}
